export function validateLossLimit(amount) {
  if (amount <= 0) return [false, 'Amount must be larger than zero.'];
  return [true, ''];
}
